export const CUSTOMER_ENDED_LOCK_REASON = 'customer_ended';
